import React, { useState, useEffect, useRef } from "react";
import { Routes, Route, } from "react-router-dom";
import gsap from "gsap";
import Login from "./components/Login";
import "./App.css";
import taj from "./assets/images/taj.jpg";
import hampi from  "./assets/images/hampi.jpg";
import jaipur from "./assets/images/jaipur.jpg";
import varanasi from  "./assets/images/varanasi.webp";
import gateway from  "./assets/images/gateway.webp";
import qutubminar from "./assets/images/qutubminar.jpg";
import state from "./assets/images/state.jpg";
import logo from "./assets/images/logo.png";
import defalt from "./assets/images/default.png"; 
/* ================= DATA ================= */

const HERITAGE_IMAGES = [
  { src: taj, title: "Taj Mahal, Agra" },
  { src: hampi, title: "Hampi, Karnataka" },
  { src: jaipur, title: "Jaipur City Palace, Rajasthan" },
  { src: varanasi, title: "Varanasi Ghats, Uttar Pradesh" },
  { src: gateway, title: "Gateway of India, Mumbai" },
  { src: qutubminar, title: "Qutub Minar, Delhi" },
  // { src: state, title: "State Map of India" },

];

const LETTER_ROWS = [
  "भारतसंस्कृतिधर्मइतिहास".split(""),
  "தமிழ்பண்பாடுவரலாறு".split(""),
  "తెలుగుసంస్కృతిచరిత్ర".split(""),
  "ಕನ್ನಡಸಂಸ್ಕೃತಿಇತಿಹಾಸ".split(""),
  "বাংলাসংস্কৃতিইতিহাস".split(""),
];

const ASPECT_CARDS = [
  { label: "Heritage", icon: "🏛️", colorClass: "heritage" },
  { label: "Culture", icon: "🎭", colorClass: "culture" },
  { label: "History", icon: "📜", colorClass: "history" },
  { label: "Geography", icon: "🗺️", colorClass: "geo" },
  { label: "Population", icon: "👥", colorClass: "pop" },
  { label: "Festivals", icon: "🎉", colorClass: "fest" },
  { label: "Tradition", icon: "🧵", colorClass: "trad" },
  { label: "Climate", icon: "🌤️", colorClass: "climate" },
  { label: "Seasons", icon: "🍂", colorClass: "season" },
  { label: "Language", icon: "🗣️", colorClass: "lang" },
];

// const MIZO_DATA = {
//   history: { title: "HISTORY", icon: <History size={24} />, text: "Mizoram's journey from tribal sovereign states to Indian statehood in 1987 is a saga of resilience." },
//   heritage: { title: "HERITAGE", icon: <Castle size={24} />, text: "Home to ancient megaliths and the legendary Vangchhia archeological site." },
//   culture: { title: "CULTURE", icon: <Users size={24} />, text: "Defined by 'Tlawmngaihna'—a code of ethics that prioritizes selflessness and community." },
//   tradition: { title: "TRADITION", icon: <Sparkles size={24} />, text: "Traditional life revolves around 'Jhum' cultivation and the vibrant Chapchar Kut festival." }
// };

/* ================= APP ================= */

export default function App() {

  const [index, setIndex] = useState(0);

  const imageRef = useRef(null);
  const ringRef = useRef(null);
  const captionRef = useRef(null);

  /* hero image rotation */
  useEffect(() => {
    const id = setInterval(
      () => setIndex((p) => (p + 1) % HERITAGE_IMAGES.length),
      5000
    );
    return () => clearInterval(id);
  }, []);

  /* image animation */
  useEffect(() => {
    gsap.fromTo(
      imageRef.current,
      { opacity: 0, scale: 1.02 },
      { opacity: 1, scale: 1, duration: 0.6 }
    );
    gsap.fromTo(
      captionRef.current,
      { opacity: 0, y: 6 },
      { opacity: 1, y: 0, duration: 0.4 }
    );
  }, [index]);

  /* ring rotate */
  useEffect(() => {
    gsap.to(ringRef.current, {
      rotation: 360,
      duration: 26,
      repeat: -1,
      ease: "linear",
    });
  }, []);

  const current = HERITAGE_IMAGES[index];

  return (

    <div className="root">

      {/* NAVBAR */}
      <header className="navbar">
        <div className="nav-left"> 
         < img src={logo} alt={defalt} className="nav-logo" loading="lazy" />
          <span className="brand-name">Heritage AI</span>
        </div>

        <nav className="nav-right">
          <a href="https://map.aryaavart.in/">Map</a>
          <a href="https://heritage-ui-hazel.vercel.app">TravelMate AI</a>
          <a href="https://map.aryaavart.in/translation">Translation</a>
        </nav>
      </header>

      {/* ROUTES */}

      <Routes>

        {/* LOGIN PAGE */}
        <Route path="/login" element={<Login />} />

        {/* HOME PAGE */}
        <Route path="/" element={

          <>
            {/* LETTER STREAM */}
            <div className="letter-stream">
              {LETTER_ROWS.map((letters, rowIndex) => {
                const top = 50 + (rowIndex - 2) * 8;
                const dirClass = rowIndex % 2 === 0 ? "left" : "right";
                return (
                  <div className="letter-row" key={rowIndex} style={{ top: `${top}%` }}>
                    <div className={`marquee ${dirClass}`}>
                      <div className="track">
                        {[...letters, ...letters].map((c, i) => (
                          <span className="letter" key={i}>{c}</span>
                        ))}
                      </div>
                      <div className="track">
                        {[...letters, ...letters].map((c, i) => (
                          <span className="letter" key={`b-${i}`}>{c}</span>
                        ))}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* MAIN CONTENT */}
            <main className="main-content-wrapper">

              {/* HERO */}
              <div className="container">
                <h1 className="tricolor-text">Heritage of India</h1>
                <p className="subtitle">Unity in Diversity</p>

                <div className="circle-wrapper">
                  <div className="circle-ring" ref={ringRef} />
                  <div className="circle-photo">
                    <img ref={imageRef} src={current.src} alt={current.title} />
                  </div>
                </div>

                <div className="caption" ref={captionRef}>
                  <h2>{current.title}</h2>
                </div>
              </div>
              {/* statemap */}
              <div className="state-map-section" id="map">
                <h2 className="map-heading">Explore Every Indian State</h2>
                <div className="state-map-wrapper">
                  <img src={state} alt="State Map" className="state-map" />

                  <div className="corner-line top-left"><span className="moving-dot" /><span className="corner-box" /><span className="corner-label">History</span></div>
                  <div className="corner-line top-right"><span className="moving-dot" /><span className="corner-box" /><span className="corner-label">Heritage</span></div>
                  <div className="corner-line bottom-left"><span className="moving-dot" /><span className="corner-box" /><span className="corner-label">Culture</span></div>
                  <div className="corner-line bottom-right"><span className="moving-dot" /><span className="corner-box" /><span className="corner-label">Tradition</span></div>
                </div>
              </div>
              

              {/* TIMELINE */}
              <h2 className="timeline-heading">Cultural Timeline of India</h2>

              <section className="timeline-section">
                <div className="timeline">
                  <div className="timeline-item"><span className="timeline-dot" /><h3>Ancient India</h3><p>Indus Valley, Vedic culture and philosophy.</p></div>
                  <div className="timeline-item"><span className="timeline-dot" /><h3>Medieval India</h3><p>Empires, temples and literature.</p></div>
                  <div className="timeline-item"><span className="timeline-dot" /><h3>Colonial Era</h3><p>Freedom struggle and resistance.</p></div>
                  <div className="timeline-item"><span className="timeline-dot" /><h3>Modern India</h3><p>Innovation and diversity.</p></div>
                </div>
              </section>
              {/* ============ TOOLS ============ */}
<section className="tools-wrap">
  <div className="passing-lines">
    <span className="line saffron l1" />
    <span className="line red l2" />
    <span className="line saffron l3" />
    <span className="line red l4" />
  </div>

  <section className="tools-section">
    <h2 className="tools-heading">Interactive Tools & Features</h2>
    <p className="tools-subtitle">Explore India using smart digital tools.</p>

    <div className="tools-row">
      <div className="tool-card">
        <div className="tool-icon">🗺️</div>
        <h3>State Map</h3>
        <p>Explore state-wise heritage.</p>
      </div>

      <div className="tool-card">
        <div className="tool-icon">🤖</div>
        <h3>TravelMate AI</h3>
        <p>Ask about culture and travel.</p>
      </div>

      <div className="tool-card">
        <div className="tool-icon">🌐</div>
        <h3>Translation</h3>
        <p>Multiple Indian languages.</p>
      </div>
    </div>
  </section>
</section>


{/* ============ ASPECT GRID ============ */}

<h2 className="timeline-heading">Information You’ll Discover</h2>

<section className="aspect-section">

  <div className="aspect-row">

    {Array.from({ length: 5 }).map((_, i) => (
      <div key={`r1-g-left-${i}`} className="aspect-card aspect-card--ghost" />
    ))}

    {ASPECT_CARDS.slice(0, 3).map((item) => (
      <div
        key={item.label}
        className={`aspect-card aspect-card--icon ${item.colorClass}`}
      >
        <div className="aspect-icon">{item.icon}</div>
        <div className="aspect-label">{item.label}</div>
      </div>
    ))}

    {Array.from({ length: 5 }).map((_, i) => (
      <div key={`r1-g-right-${i}`} className="aspect-card aspect-card--ghost" />
    ))}

  </div>


  <div className="aspect-row">

    {Array.from({ length: 4 }).map((_, i) => (
      <div key={`r2-g-left-${i}`} className="aspect-card aspect-card--ghost" />
    ))}

    {ASPECT_CARDS.slice(3, 7).map((item) => (
      <div
        key={item.label}
        className={`aspect-card aspect-card--icon ${item.colorClass}`}
      >
        <div className="aspect-icon">{item.icon}</div>
        <div className="aspect-label">{item.label}</div>
      </div>
    ))}

  </div>


  <div className="aspect-row">

    {Array.from({ length: 5 }).map((_, i) => (
      <div key={`r3-g-left-${i}`} className="aspect-card aspect-card--ghost" />
    ))}

    {ASPECT_CARDS.slice(7, 10).map((item) => (
      <div
        key={item.label}
        className={`aspect-card aspect-card--icon ${item.colorClass}`}
      >
        <div className="aspect-icon">{item.icon}</div>
        <div className="aspect-label">{item.label}</div>
      </div>
    ))}

    {Array.from({ length: 5 }).map((_, i) => (
      <div key={`r3-g-right-${i}`} className="aspect-card aspect-card--ghost" />
    ))}

  </div>

</section>
            </main>

            {/* FOOTER */}
            <footer className="footer">
              <div className="footer-inner">
                <div className="footer-left">
                  <span className="footer-brand">Heritage AI</span>
                  <p>Exploring India’s heritage through intelligent tools.</p>
                </div>

                <div className="footer-right">
                  <a href="https://map.aryaavart.in/">Map</a>
                  <a href="https://heritage-ui-hazel.vercel.app/">TravelMate AI</a>
                  <a href="https://map.aryaavart.in/translation">Translation</a>
                </div>
              </div>

              <div className="footer-bottom">
                © {new Date().getFullYear()} Heritage AI
              </div>
            </footer>

          </>
        } />
        {/* OTHER PAGES (to be implemented) */}
      </Routes>

    </div>
  );
}